import React, { Component } from 'react';
import { init } from '@alilc/lowcode-engine';

export default class DashboardApp extends Component {
  $container: HTMLElement;
  componentDidMount() {
    if (this.$container) {
      init(this.$container, {
        enableCondition: true
      })
    }
  }

  render() {
    return (
      <div ref={($container) => { this.$container = $container }}></div>
    )
  }
}